// extracted by mini-css-extract-plugin
module.exports = {"navbar":"_3aRBl6eS","custom-nav-underline":"_36aiFucz","custom-nav-link":"CKUAFwg6","active":"EhSsSoI1","show":"aMv1cnTg","menu-nav-icon-wrapper":"_1HKJw6Sp"};